import { type ColumnDef } from '@tanstack/react-table';

import { cx } from '@/lib/cx';
import { formatarDataHora } from '@/lib/formato';
import { Status } from '@/ui/components/status';
import { type Lote } from '@fiscoai/contracts';

import { emAndamento } from './api';
import { resumoDoLote, textoDoResumo, tituloDoLote } from './resumo-lote';
import { STATUS_LOTE } from './rotulos';

/** Colunas do histórico completo: quando, o quê, quem, situação e o resultado em uma frase. */
export const colunasLotes: ColumnDef<Lote>[] = [
  {
    id: 'quando',
    header: 'Enviado em',
    meta: { largura: '11rem', ordenavel: 'criadoEm' },
    cell: ({ row }) => (
      <span className="tabular text-sm">{formatarDataHora(row.original.criadoEm)}</span>
    ),
  },
  {
    id: 'envio',
    header: 'Envio',
    meta: { ordenavel: 'totalItens' },
    cell: ({ row }) => <span className="font-medium">{tituloDoLote(row.original)}</span>,
  },
  {
    id: 'resultado',
    header: 'Resultado',
    cell: ({ row }) => {
      const lote = row.original;
      const resumo = resumoDoLote(lote);
      return (
        <span className={cx('text-sm', resumo.problemas > 0 ? 'text-alerta' : 'text-texto-suave')}>
          {emAndamento(lote.status)
            ? `${String(lote.processados)} de ${String(lote.totalItens)} processados`
            : textoDoResumo(resumo)}
        </span>
      );
    },
  },
  {
    id: 'por',
    header: 'Por',
    meta: { largura: '11rem' },
    cell: ({ row }) => (
      <span className="text-sm text-texto-suave">{row.original.criadoPor.nome}</span>
    ),
  },
  {
    id: 'situacao',
    header: 'Situação',
    meta: { largura: '12rem' },
    cell: ({ row }) => {
      const status = STATUS_LOTE[row.original.status];
      return (
        <Status tom={status.tom} ativo={emAndamento(row.original.status)}>
          {status.rotulo}
        </Status>
      );
    },
  },
];
